const url = process.env.VUE_APP_API_BASE_URL;
const googleApi = "http://maps.googleapis.com/maps/api/";

const config = {
  url,
  googleApi,
};

console.log(url);

// config.exports = {
//   devServer: {
//     proxy: "http://localhost:8000",
//   },
// };

// module.exports = {
//   transpileDependencies: ["vuetify"],
//   devServer: {
//     proxy: "http://localhost:8000",
//   },
// };

export default config;
// export default data;
